<template>
  <div
    class="form-container position-absolute top-50 start-50 w-25 translate-middle"
  >
    <!-- ------------ -->
    <!--    header    -->
    <!-- ------------ -->
    <div class="outer-area">
      <div class="auth-box text-center">
        <img
          class="mt-4"
          src="/bbLogo32Blue.png"
          alt="logo"
        />
        <p class="fw-lighter mt-4 mb-4 bb-app-heading">BATTLEBOARD</p>
        <p class="fs-6 mt-5 mb-5 bb-app-subheading">{{ getPageTitle }}</p>
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="forgottenPassword">
          <div class="form-group">
            <!-- ------------ -->
            <!--     email    -->
            <!-- ------------ -->
            <div class="form-floating mb-3">
              <input
                v-model="email"
                onkeyup="this.value = this.value.toLowerCase();"
                type="text"
                name="email"
                id="floatingEmail"
                placeholder="email"
                class="form-control"
                required
              />
              <label
                class="bb-float-label"
                for="floatingEmail"
                >Email</label
              >
            </div>
          </div>
          <!-- ------------ -->
          <!--    message   -->
          <!-- ------------ -->
          <p class="fs-6 mt-4 mb-3 bb-message">
            Please provide your email address registered with your account to
            receive a password reset email.
          </p>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div
            v-for="err in errors"
            :key="err.id"
            class="bb-error-wrap mt-2"
          >
            {{ err }}
          </div>
          <!-- ------------ -->
          <!--    submit    -->
          <!-- ------------ -->
          <div class="d-grid gap-3">
            <button
              type="submit"
              :disabled="!email"
              class="btn btn-lg btn-primary mt-3 mb-3"
            >
              Reset Password
            </button>
          </div>
        </form>
        <!-- ------------------ -->
        <!--        login       -->
        <!-- ------------------ -->
        <div class="bb-vert-text-divider">
          <router-link
            class="bb-link"
            to="/login"
            >Login</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'forgottenPasswordView',
  data() {
    return {
      email: '',
      errors: [],
    }
  },
  //----------------------
  // computed
  //----------------------
  computed: {
    ...mapGetters('auth', {
      getPageTitle: 'getPageTitle',
    }),
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      sendPasswordResetEmail: 'sendPasswordResetEmail',
    }),
    ...mapMutations('auth', {
      setMessage: 'setMessage',
    }),
    //----------------------------
    // forgotten password method
    //----------------------------
    async forgottenPassword() {
      this.errors = []
      const payload = {
        email: this.email,
      }
      //----------------------
      // api call
      //----------------------
      await this.sendPasswordResetEmail(payload)
        //----------------------
        // successful call
        //----------------------
        .then(() => {
          //----------------------
          // to go login screen
          //----------------------
          const message = {
            text: 'If the email address you have provided is valid, a password reset email was sent.\n\nIf you do not receive this email, use the link below.',
            link: {
              to: { name: 'forgottenPasswordView' },
              label: 'Request another password reset email',
            },
          }
          this.setMessage(message)
          this.$router.push({ name: 'logoutView' })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          let error = window.bbErrorMsg(err)
          this.errors.push(error)
        })
    },
  },
  mounted() {
    document.body.className = 'bb-bg-partial'
  },
  unmounted() {
    document.body.className = 'bb-bg-full'
  },
}
</script>
